import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { booksKeys } from "@/features/books/queries/booksQueryKeys";
import booksService from "@/features/books/services/booksService";

export function useArchiveBook() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: (bookId: string) => booksService.archiveBook(bookId),
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to hide book";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: booksKeys.all });
            toast.success("Book hidden successfully");
            navigate("/books");
        },
    });
}
